import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import canopyLogo from "../../assets/icons/canopy.png";
import { VERSION_DISPLAY } from "../../config/version";
import './Navbar.css';

const Navbar = ({ light = false, logoOnly = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(true);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (!isOpen) {
      document.body.style.removeProperty('overflow');
      return undefined;
    }

    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.removeProperty('overflow');
    };
  }, [isOpen]);

  return (
    <nav
      className={`navbar ${scrolled ? 'scrolled' : ''} ${light ? 'navbar--light' : ''} ${
        logoOnly ? 'navbar--logo-only' : ''
      }`}
    >
      <div className="navbar-container">
        <NavLink to="/" className="navbar-logo">
          <img src={canopyLogo} alt="Canopy Systems" className="logo-img" />
          <span className="logo-text">Canopy Systems</span>
          <span className="version-text">{VERSION_DISPLAY}</span>
        </NavLink>

        {!logoOnly && (
          <>
            <div className={`navbar-menu ${isOpen ? 'active' : ''}`}>
              <NavLink to="/" exact className="nav-link" activeClassName="active" onClick={() => setIsOpen(false)}>
                Home
              </NavLink>
              <NavLink to="/demo" className="nav-link" activeClassName="active" onClick={() => setIsOpen(false)}>
                Demo
              </NavLink>
              <NavLink to="/autumn" className="nav-link" activeClassName="active" onClick={() => setIsOpen(false)}>
                Autumn
              </NavLink>
              <NavLink to="/parts" className="nav-link" activeClassName="active" onClick={() => setIsOpen(false)}>
                Parts
              </NavLink>
              <NavLink to="/contact" className="nav-link" activeClassName="active" onClick={() => setIsOpen(false)}>
                Contact
              </NavLink>
              <NavLink to="/login" className="nav-link login-btn" activeClassName="active" onClick={() => setIsOpen(false)}>
                Login
              </NavLink>
            </div>

            <div className="navbar-toggle" onClick={toggleMenu}>
              <span className={`hamburger ${isOpen ? 'active' : ''}`}></span>
            </div>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
